// Avantage « adaptateur doré » : la ligne offerte du panier. L'éligibilité vient de Liquid, jamais des propriétés du client.
// Même règle que lcf-discounts (cadeau-panier/src/gratuits.js) : une seule ligne offerte, marquée `_df_adapter`,
// de quantité exactement due, mise à 0 € par la transformation cadeau-prix. Jamais de ligne offerte en partie :
// un adaptateur ajouté à la main est payé. Pour que le client garde le même nombre d'adaptateurs qu'avant,
// les unités qu'il avait ajoutées à la main passent sur la ligne offerte (mémorisées dans `_df_manual`) et lui
// sont rendues, payantes, si le droit baisse (coque retirée).
((root) => {
  const AUTO = '_df_adapter';
  const FROM_MANUAL = '_df_manual';

  function adapterPlan(state) {
    const items = state.cart.items;
    const variant = Number(state.adapterVariant);
    const eligible = new Set(state.eligibleVariants.map(Number));
    const wanted = items.reduce((sum, item) => sum + (eligible.has(item.variant_id) ? item.quantity : 0), 0);
    const isAuto = (item) => item.variant_id === variant && item.properties?.[AUTO] === '1';
    const automatic = items.filter(isAuto);
    const manual = items.filter((item) => item.variant_id === variant && !isAuto(item));
    const absorbed = (item) => Math.max(0, Number(item.properties?.[FROM_MANUAL]) || 0);
    const props = (item, fromManual) => {
      const next = { ...(item?.properties || {}), [AUTO]: '1' };
      if (fromManual > 0) next[FROM_MANUAL] = String(fromManual); else delete next[FROM_MANUAL];
      return next;
    };
    const change = (item, quantity, properties) => ({ change: properties ? { id: item.key, quantity, properties } : { id: item.key, quantity } });
    const add = (quantity, properties) => ({ add: properties ? { id: variant, quantity, properties } : { id: variant, quantity } });

    // Un pas par lecture du panier ; un pas peut compter deux requêtes, l'ajout toujours avant le retrait
    // (interrompu entre les deux, le client a une unité de plus, jamais une de moins).
    let steps = [];
    const auto = automatic[0];
    const autoQty = auto ? auto.quantity : 0;
    if (automatic.length > 1) {
      // Doublons (paniers concurrents, anciens paniers) : tout sur la première ligne, mémoire comprise.
      const total = automatic.reduce((sum, item) => sum + item.quantity, 0);
      const fromManual = automatic.reduce((sum, item) => sum + absorbed(item), 0);
      steps = [change(auto, total, props(auto, fromManual)), ...automatic.slice(1).map((item) => change(item, 0))];
    } else if (wanted > autoQty && manual.length) {
      const source = manual[0];
      const take = Math.min(wanted - autoQty, source.quantity);
      const fromManual = (auto ? absorbed(auto) : 0) + take;
      steps = [auto ? change(auto, autoQty + take, props(auto, fromManual)) : add(take, props(null, fromManual)), change(source, source.quantity - take)];
    } else if (wanted > autoQty) {
      steps = [auto ? change(auto, wanted) : add(wanted, props(null, 0))];
    } else if (wanted < autoQty) {
      const giveBack = Math.min(absorbed(auto), autoQty - wanted);
      steps = [change(auto, wanted, wanted ? props(auto, absorbed(auto) - giveBack) : undefined), ...(giveBack ? [add(giveBack)] : [])];
    }

    // Montant compté pour les paliers : lignes payées seulement (ni cadeau, ni adaptateur offert), avant codes promo.
    const base = items.filter((item) => !isAuto(item) && !(item.properties?._gift && item.variant_id !== variant))
      .reduce((sum, item) => sum + item.original_line_price, 0);
    // Confirmé quand la ligne offerte a la bonne quantité et ne coûte rien (transformation, ou remise en filet).
    const confirmed = !steps.length && (wanted === 0 ? !automatic.length : autoQty === wanted && auto.final_line_price === 0);
    return { wanted, steps, base, confirmed, configured: variant > 0 };
  }
  // WEBLCFB2C-213 — personnalisation texte. La coque porte _perso_id et _perso_prix (variante de la ligne
  // « Personnalisation texte ») ; cette ligne porte _perso_id et _perso_pour. Le panier garde exactement une
  // ligne de supplément par coque personnalisée, toutes deux en quantité 1. Un pas par appel, comme les cadeaux.
  function persoPlan(items) {
    const coques = items.filter((item) => item.properties?._perso_id && !item.properties?._perso_pour);
    const lignes = items.filter((item) => item.properties?._perso_pour);
    const ids = new Set(coques.map((item) => item.properties._perso_id));
    const vues = new Set();
    for (const ligne of lignes) {
      const id = ligne.properties._perso_id;
      if (!ids.has(id) || vues.has(id)) return { change: { id: ligne.key, quantity: 0 } };
      vues.add(id);
    }
    const multiple = [...coques, ...lignes].find((item) => item.quantity !== 1);
    if (multiple) return { change: { id: multiple.key, quantity: 1 } };
    const seule = coques.find((item) => !vues.has(item.properties._perso_id));
    if (seule) {
      const prix = Number(seule.properties._perso_prix);
      if (!prix) return { erreur: true };
      return { add: { id: prix, quantity: 1, properties: { _perso_id: seule.properties._perso_id, _perso_pour: String(seule.variant_id) } } };
    }
    return {};
  }
  root.dfCartBenefits = { adapterPlan, persoPlan };
  if (typeof module !== 'undefined') module.exports = { adapterPlan, persoPlan };
})(typeof window === 'undefined' ? globalThis : window);
